import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryDeliveryColumn } from '../constants/dictionary-delivery-columns.constant';
import { trxIdHandle } from './trx-id.handle';

export const generateDeliveryColumns = () => {
	return [
		{
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].operation_id,
			dataIndex: 'operation_id',
			key: 'operation_id',
		},
		{
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].schedule_selected,
			dataIndex: 'schedule_selected',
			key: 'schedule_selected',
		},
		{
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].type_retirement,
			dataIndex: 'type_retirement',
			key: 'type_retirement',
		},
		{
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].trx_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
			render: (trx_id) => trxIdHandle(trx_id),
		},
	];
};
